import React from 'react';
import 'video.js/dist/video-js.css';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import IntervalService from './../../services/intervals';
import { ReactComponent as PlayIcon } from './../../assets/play.svg';
import { ReactComponent as PauseIcon } from './../../assets/pause.svg';
import { ReactComponent as PrevIcon } from './../../assets/prev.svg';
import { ReactComponent as NextIcon } from './../../assets/next.svg';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { LinearProgress } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import SvgIcon from '@mui/material/SvgIcon';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import Typography from '@mui/material/Typography';
import navigationStore from '../../stores/navigation';
import playerStore from './../../stores/player';
import sessionStore from '../../stores/session';
import performanceStore from '../../stores/performance';

function FixedPlayerButtons(props) {

  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const isPlaying = playerStore((state) => state.isPlaying);
  const safeArea = navigationStore((state) => state.safeArea);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const setFrom = playerStore((state) => state.setFrom);
  const history = performanceStore((state) => state.history);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const getNextPerformance = performanceStore((state) => state.getNextPerformance);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const addPerformanceToHistory = performanceStore((state) => state.addPerformanceToHistory);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const currentVersion = playerStore((state) => state.currentVersion);
  const isPlayListOn = performanceStore((state) => state.isOn);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const prevFromHistory = performanceStore((state) => state.prevFromHistory);
  const isStopped = playerStore((state) => state.isStopped);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const isFocused = playerStore((state) => state.isFocused);
  const setIsReady = playerStore((state) => state.setIsReady);
  const isReady = playerStore((state) => state.isReady);
  const currentTrack = playerStore((state) => state.currentTrack);
  const streamUrl = playerStore((state) => state.streamUrl);
  const countdown = performanceStore((state) => state.countdown);
  const isSwitching = playerStore((state) => state.isSwitching);

  const stop = () => {
    IntervalService.clearAllIntervals();
    if (!isStopped.isStopped) {
      setIsPlaying(false);
      setIsStopped(true);
      setCurrentTime(0);
    }
    setFrom(0);
  };

  const next = (e) => {
    e.stopPropagation();
    setFrom(0);
    setTimeout(() => {
      setIsAutoPlayOn(true);
      stop();
      addPerformanceToHistory(sessionToken, currentPerformance);
      deletePerformance(sessionToken, currentPerformance.unique_id);
      if (isPlayListOn) {
        let nextPerformance = getNextPerformance();
        if (nextPerformance) {
          getStreamUrl(sessionToken, nextPerformance, nextPerformance.track, nextPerformance.pitch, currentVersion);
        }
      }
    }, 50);
  };

  const prev = (e) => {
    e.stopPropagation();
    setIsAutoPlayOn(true);
    playerStore.getState().setIsTrackLogSent(null);
    let currentTimeNow = playerStore.getState().currentTime;
    stop();
    console.log("stop", currentTimeNow);
    if (history.items.length > 0) {
      if (currentTimeNow == 0) {
        console.log("stop", currentTimeNow);
        prevFromHistory(sessionToken);
      }
    }
  };

  const play = () => {
    console.log("network error", isFocused, isReady, currentPerformance, currentTrack);
    if (isFocused && isReady && !isSwitching) {
      setIsReady(false);
      if (currentPerformance && currentTrack) {
        console.log("currentTrack", isFocused, currentPerformance, currentTrack, streamUrl);
        IntervalService.clearAllIntervals();
        setIsPlaying(true);
        setIsStopped(false);
        if (streamUrl === "") {
          getStreamUrl(sessionToken, currentPerformance, currentTrack, currentPerformance.pitch, currentVersion, 0, true);
        }
      } else {
        if (streamUrl === "") {
          setIsStopped(false);
          getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, currentPerformance.pitch, currentVersion, 0, true);
        }
      }
    }
  };

  const pause = () => {
    if (isReady) {
      setIsReady(false);
      setIsPlaying(false);
    }
  };

  const renderPrevButton = () => {
    return <IconButton className="muvika-player-toggle-button" value="check" onClick={prev}>
      <SvgIcon className="muvika-icon" component={PrevIcon} />
    </IconButton>;
  };

  const renderNextButton = () => {
    return <IconButton className="muvika-player-toggle-button" value="check" onClick={next}>
      <SvgIcon className="muvika-icon" component={NextIcon} />
    </IconButton>;
  };

  const renderPauseOrPlay = () => {
    if (isPlaying.isPlaying) {
      return <IconButton className="muvika-mobile-player-button" color="white" component="label" size="small" onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        pause();
      }}>
        <SvgIcon className="muvika-icon" component={PauseIcon} />
      </IconButton>;
    } else {
      return <IconButton className="muvika-mobile-player-button" color="white" component="label" size="small" onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        play();
      }}>
        <SvgIcon className="muvika-icon" component={PlayIcon} />
      </IconButton>;
    }
  };

  const fixedPlayerSecondary = () => {
    if (countdown > 0) {
      return countdown + "s - " + currentPerformance?.profile?.name + " - " + currentPerformance?.track?.title;
    }
    return currentPerformance?.profile?.name + " - " + currentPerformance?.track?.title;
  };

  return (
    <Card
      id={props.id}
      elevation={10}
      onClick={props.onClick}
      sx={props.sx}
    >
      {(() => { console.log("render fixed player buttons"); })()}
      <CardMedia
        component="img"
        className="muvika-mobile-player-card-image"
        image={props.image}
      />
      <Box className="muvika-fixed-player-buttons-content-box">
        <CardContent className="muvika-mobile-player-card-content-div">
          <Grid container spacing={0.5} alignItems="center">
            {/* Left buttons */}
            <Grid item>
              {renderPrevButton()}
              {renderPauseOrPlay()}
              {renderNextButton()}
            </Grid>

            {/* Center content (flexible) */}
            <Grid item xs sx={{ textAlign: "left", overflow: "hidden" }}>
              <Typography className="muvika-mobile-player-card-content-title" component="div" variant="primary" noWrap>
                {fixedPlayerSecondary()}
              </Typography>
              <Typography className="muvika-mobile-player-card-content-artist" variant="secondary" color="text.secondary" component="div" noWrap>
                {props.primary}
              </Typography>
            </Grid>

            {/* Right content */}
            <Grid item>
              <Typography className="muvika-mobile-player-card-content-title" component="div" variant="primary" sx={{ textAlign: "right" }} noWrap>
                <span>{props.pitch !== 0 ? `${props.pitch > 0 ? "+" : ""}${props.pitch} ` : ""}{props.length}</span>
              </Typography>
              <Typography className="muvika-mobile-player-card-content-artist" variant="secondary" color="text.secondary" component="div" sx={{ textAlign: "right" }} noWrap>
                {props.kcode}
              </Typography>
            </Grid>
          </Grid>

        </CardContent>
      </Box>
      <VerticalAlignTopIcon className="muvika-mobile-player-card-full-icon" />
      <LinearProgress sx={{
      }} className="muvika-player-buttons-progress" variant="determinate" value={props.currentProgress} />
    </Card>
  );
}

export default FixedPlayerButtons;